// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2bm4H","title":"AfterBackImages_title__2sBmA","images":"AfterBackImages_images__1_dii"};